import { styled } from '@mui/material';

export const SharedStyles = {
  PageSection: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(2)
  })),

  RectangleBar: styled('div')({
    margin: '0 auto',
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px'
  }),

  EmptyState: styled('div')(({ theme }) => ({
    border: '1px dashed #C7C7C7',
    borderRadius: 8,
    padding: theme.spacing(3),
    color: '#5D5F64',
    backgroundColor: '#FAFAFA'
  }))
};
